export { default as MultiselectAdapter } from './multiselect-adapter'
export * from './multiselect-adapter.reducer'
export { default as epics } from './multiselect-adapter.epic'



// WEBPACK FOOTER //
// ./src/modules/forms/multiselect-adapter/index.ts